<template>
  <div class="morecontents">
      <div class="more">
        <div class="title">多种接口，兼容更多</div>
        <div class="write">维码器适用于各种自助投币设备，兼容性强</div>
        <div class="port">
            <div class="port-on">
                <div class="on">开<br/>关</div>
                <div class="or">or</div>
                <div class="aerial">天<br/>线</div>
            </div>
            <div class="port-list">
                <div class="port-left">
                <div class="one">SW1</div>
                <div class="one">J4 <br/>
                    机台方向</div>
                <div class="one">J5<br/>
                    码表方向</div>
              </div>
            <div class="port-middle"><img src="./images/phone/Product_Inter.png" alt="维码器接口"></div>
            <div class="port-right">
                <div class="one">J3<br/>
                    单口</div>
                <div class="one">J2 <br/>
                    机台方向</div>
                <div class="one">J1<br/>
                    投币器座</div>
             </div>
            </div> 
            
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'more',
}
</script>

<style scoped>
.morecontents{
    width:100%;
    /* height: 100%; */
    background-color: #fafafa;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.more{
    width:100%;
    /* height: 100%; */
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    
}
.more .title{
font-size: 22px;
line-height: 22px;
letter-spacing: 0.5px;
color: #000000;
margin-top: 50px;
}
.more .write{
font-size: 11px;
line-height: 11px;
color: #000000;
margin-top:12.5px;
}
.more .port{
margin: 48px 0px;
display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
}
.more .port .port-list{
    width: 90%;
        display: flex;
    justify-content: center;
    align-items: center;
}
.more .port .port-middle{
    width: 70%;
}
.more .port .port-middle img{
    width: 100%;
}
.port .one{
    font-size: 11px;
}
.port-left,.port-right{
    height: 60vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    text-align: center;
}
.port-on{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 12vw;
    position: absolute;
    top: 21vw;
    left: 30vw;
}
.on,.or,.aerial{
    font-size: 11px;
    letter-spacing: 0px;
	color: #fff;
}
</style>




// WEBPACK FOOTER //
// src/components/hardProduct/more.vue